import { render, staticRenderFns } from "./SummaryPointList.vue?vue&type=template&id=6529af22"
import script from "./SummaryPointList.vue?vue&type=script&lang=js"
export * from "./SummaryPointList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports